<template>
    <main>
        <div class="container-fluid">
            <div class="row">
                <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="mainButton">
                        <breadcrumbs></breadcrumbs>
                    </div>
                    <div class="page-toolbar">
                        <div class="page-title">
                            <span class="title">Scheduler</span> 
                            <span class="star"> <i class="fa-solid fa-star"></i></span>
                        </div>
                        <div class="page-create-button">
                            <router-link to="/modules/schedulers/edit" class="btn-create">Create</router-link>
                        </div>
                        <div class="page-filter">
                           <input type="search" value="" placeholder="Searching..." class="form-control" v-on:click="openAction">
                           <CustomSearch v-bind:class="{ active: isActive }" @searchEvent="childMethod" @openAction="openAction"></CustomSearch>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <GenericList v-if="generic" ref="loadGeneric"></GenericList>
        <CustomList v-else ref="loadCustom"></CustomList>
       
       <div class="container-fluid">
            <div class="card">
                <div class="card-header">
                <h3>To Setup Crontab</h3>
                   
                </div>
                <div class="card-body">
                <p class="mb-1">Add this line to your crontab:</p>
                 <p><b>*&nbsp;*&nbsp;*&nbsp;*&nbsp;*&nbsp; cd {{realpath}}  && php artisan schedule:run >> /dev/null 2>&1</b></p>
                </div>
            </div>
       </div>
        
    </main>
</template>



<script>
import { ref } from "vue";
import breadcrumbs from "@/views/modules/Schedulers/MenuList.vue";
import lang from "@/views/modules/Schedulers/language/en";
import GenericList from "@/components/layout/shared/generic/ListView.vue";
import CustomList from "@/views/modules/Schedulers/ListView.vue";
import CustomSearch from "@/views/modules/Schedulers/SearchView.vue";
    export default {
        name: "list-scheduler",
        components: {
            breadcrumbs,
            GenericList,
            CustomList,
            CustomSearch,
        },
        data() {
            return {
                generic: true,
                isActive:false,
                realpath:window.app.realpath,
                metaList: [
                    {
                        label: 'Job Name',
                        link: true,
                        moduleName: 'Schedulers',/// moduleName is required
                        routePath: 'schedulers',/// routePath is required at start of object folder name
                        isSort:true,
                        field_name:'name',
                    },
                    {
                        label: 'Job',
                        link: false,
                        routePath: '',
                        isSort:true,
                        field_name:'job',
                    },
                    {
                        label: 'Status',
                        link: false,
                        routePath: '',
                        isSort:true,
                        field_name:'status',
                    },
                ],
                columns: ['name', 'job', 'status'],

            }
        },
        mounted() {
            this.childMethod();
            this.lang = lang;
        },
        methods: {

            childMethod() {
                 if (this.generic == true) {
                    this.$refs.loadGeneric.loadGenericView(this.metaList, this.columns);
                 }
            },
            openAction() {
                this.isActive = !this.isActive;
            },
        }
    }
</script>